// Unpublished Work © 2020-2022 Deere & Company

import * as actions from '../../action-list';
import {Customer} from '../../state/struct/customer';

const setPotentialMatches = (state, action) => action.potentialMatches.map((match) => Customer(match));

export const potentialMatches = (state = [], action = {}) => {
    const actionHandlers = {
        [actions.SET_POTENTIAL_MATCHES]: setPotentialMatches
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
